import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as currentProductsFromSomeoneElseState from '../employee-detail.reducer';
import * as currentProductsFromSomeoneElseReducer from '../reducers/current-products-from-someone-else.reducer';

export const getCurrentProductsFromSomeoneElse = createSelector(
  currentProductsFromSomeoneElseState.getCurrentProductsFromSomeoneElseState,
  currentProductsFromSomeoneElseReducer.getCurrentProductsFromSomeoneElseResponse
);
